import Home from "@/components/Dashboard/Home.vue";
import ResourceManager from "@/components/Dashboard/ResourceManager.vue";

export default [
    {
        path: 'home',
        name: 'Home',
        components: {
            page: Home,
        },
        meta: {
            requiresAuth: true
        },
        children: [
            /*
            {
                path: "filter",
                name: "Filter",
                components: {
                    modal: Filter
                }
            },
            {
                path: "list/:filter?",
                name: "List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Edit",
                components: {
                    modal: Edit,
                }
            }
            */
        ]
    },
    {
        path: 'resource-manager',
        name: 'ResourceManager',
        components: {
            page: ResourceManager,
        },
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    }
];